module.exports = __webpack_public_path__ + "img/history.e2f1906.png";